<template>
  <section>
    <!--工具条-->
    <LineManVehicleToolbar :buttonList="buttonList" @callFunction="callFunction"></LineManVehicleToolbar>

    <!--列表-->
    <el-table
      :data="lineManVehicleList"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%;"
    >
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        fixed="left"
        label="操作"
        width="130">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide && scope.row.IsBind === false && item.name === '绑定'" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="LineName" label="线路名称" width="130"></el-table-column>
      <el-table-column prop="ShiftsQuantity" label="班次数量" width="130"></el-table-column>
      <el-table-column prop="DriversQuantity" label="司机数量" width="100"></el-table-column>
      <el-table-column
        label="司机明细"
        width="320">
        <template slot-scope="scope">
          <span v-for="item in scope.row.VehicleLine" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" @click="handleDriverEdit(item.VehicleId,item.BusLinesId,item.DriverId)">{{item.DriverName}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="VehicleQuantity" label="车辆数" width="100"></el-table-column>
      <el-table-column
        label="车辆明细"
        width="350">
        <template slot-scope="scope">
          <span v-for="item in scope.row.VehicleLine" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" @click="handleVehicleEdit(item.VehicleId,item.BusLinesId,item.DriverId)">{{item.LicensePlateNumber}}</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--绑定-->
    <el-dialog
      title="绑定"
      :visible.sync="bindingFormVisible"
      v-model="bindingFormVisible"
      :close-on-click-modal="false"
      width="65%"
    >
      <el-form :model="bindingForm" label-width="80px" ref="bindingForm">
        <el-row>
          <el-col :span="8">
            <el-form-item label="线路名称" prop="LineName" label-width="110px">
              <el-input v-model="bindingForm.LineName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-form-item label="绑定" label-width="110px">
            <el-col :span="11">
                <el-table
                  ref="unBindingTable"
                  v-loading="bindingListLoading"
                  :key="tableKey"
                  :data="vehicleUnboundList"
                  border
                  fit
                  highlight-current-row
                  @selection-change="handleBindingChange"
                  :row-key="getRowKeys" 
                  max-height="450"
              >
              <el-table-column label="待绑信息">
                <el-table-column>
                  <template slot="header" slot-scope="{row}">
                    <el-input
                      v-model="leftLicensePlateNumber"
                      size="mini"
                      placeholder="请输入车牌"
                      v-on:input="leftLicensePlateNumberChange"
                      @change="((val)=>{inputChange(val, row)})"
                      ></el-input>
                  </template>
                  <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
                    <el-table-column label="车牌" align="center">
                      <template slot-scope="{row}">
                        <span>{{ row.LicensePlateNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="司机" align="center">
                      <template slot-scope="scope">
                        <el-select style="width: 100%;" @change="((val)=>{driverChange(val, scope.row.Id)})" v-model="scope.row.DriverId" filterable placeholder="请选择司机">
                          <el-option
                            v-for="item in driverList"
                            :key="item.Id"
                            :value="item.Id"
                            :label="item.Name"
                            >
                            <span style="float: left">{{ item.Name }}</span>
                          </el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="2" style="text-align:center;">
              <el-button
                @click="addBinding"
                type="primary"
                :disabled="!bindingData.length"
                icon="el-icon-arrow-right"
                circle
              ></el-button>
              <el-button
                @click="removeBinding"
                type="primary"
                :disabled="!selectedBindingData.length"
                icon="el-icon-arrow-left"
                circle
                style="margin-left: 0;margin-top: 10px;"
              ></el-button>
            </el-col>
            <el-col :span="11">
              <el-table
                ref="selectedBindingTable"
                v-loading="rightBindingListLoading"
                :key="tableKey"
                :data="selectedBindingList"
                border
                fit
                highlight-current-row
                @selection-change="handleSelectedBindingChange"
                :row-key="getRowKeys" 
                max-height="450"
              >
                <el-table-column label="已绑信息">
                  <el-table-column>
                    <template slot="header" slot-scope="{row}">
                      <el-input
                        v-model="rightLicensePlateNumber"
                        size="mini"
                        v-on:input="rightLicensePlateNumberChange"
                        @change="((val)=>{inputChange(val, row)})"
                        placeholder="请输入车牌或司机"/>
                    </template>
                    <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
                    <el-table-column label="车牌" align="center">
                      <template slot-scope="{row}">
                        <span>{{ row.LicensePlateNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="司机" align="center">
                      <template slot-scope="{row}">
                        <span>{{ row.DriverName }}</span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="bindingFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="bindingSubmit" :loading="bindingLoading">提交</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getLineManVehicleListPage,putBindingVehiclesList,getDriverListPage,getVehiclesListPage,exportExcel } from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import LineManVehicleToolbar from "../../components/QueryToolbar/LineManVehicleToolbar";

export default {
  components: { LineManVehicleToolbar },
  data() {
    return {
      filters: {
        busLinesId: "",
        driverId: "",
        vehicleId: ""
      },
      buttonList: [],
      operationButtonList: [],
      lineManVehicleList: [], //线路人车绑定列表
      driverList: [], //驾驶员列表
      vehicleList: [], //车辆列表
      vehicleUnboundList: [], //待绑列表
      bindingData : [], //已选需要绑定的数据
      selectedBindingData : [], //已选需要解绑的数据
      selectedBindingList: [], //已绑定列表
      selectedBindingBackupList: [], //已绑定备份列表
      tableKey: 0,
      bindingListLoading: true, //待绑列表加载
      rightBindingListLoading: false, //右边待绑列表加载
      leftLicensePlateNumber:"", //左边过滤输入框
      rightLicensePlateNumber:"", //右边过滤输入框
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      operatingStatusList: [
        { name: "营运", value: true },
        { name: "停运", value: false }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      bindingFormVisible: false, //绑定界面是否显示
      bindingLoading: false,
      //绑定界面数据
      bindingForm: {
        BusLinesId: 0,
        LineName: "",
        Vehicles: [] //已绑车辆列表
      }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    getRowKeys(row) {
      return row.Id;
    },
    callFunction(item) {
      this.filters = {
        busLinesId: item.busLinesId,
        driverId: item.driverId,
        vehicleId: item.vehicleId
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getLineManVehicle();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getLineManVehicle();
    },
    queryLineManVehicle(){
      this.page = 1;
      this.getLineManVehicle();
    },
    //获取线路人车绑定列表
    getLineManVehicle() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        driverId: _this.filters.driverId,
        vehicleId: _this.filters.vehicleId,
        isBind: 'false',
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getLineManVehicleListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.lineManVehicleList = res.data.response.data;
        _this.listLoading = false;
      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    leftLicensePlateNumberChange(value){
      this.vehicleUnboundListInit();
      if(value !== "" && this.vehicleUnboundList.length > 0){
        this.vehicleUnboundList = this.vehicleUnboundList.filter(it=>it.LicensePlateNumber.indexOf(value) > -1);
      }
    },
    rightLicensePlateNumberChange(value){
      this.selectedBindingListInit();
      if(value !== "" && this.selectedBindingList.length > 0){
        this.selectedBindingList = this.selectedBindingList.filter(it=>it.LicensePlateNumber.indexOf(value) > -1 || (it.DriverName !== "" && it.DriverName !== null && it.DriverName.indexOf(value) > -1));
      }
    },
    inputChange(val,Id){

    },
    //绑定
    handleBinding(){
      this.bindingFormVisible = true;
      this.bindingForm.BusLinesId = this.currentRow.BusLinesId;
      this.bindingForm.LineName = this.currentRow.LineName;
      this.bindingData = []; //初始化已选需要绑定的数据
      this.selectedBindingData = []; //初始化已选需要解绑的数据
      this.selectedBindingList = []; //初始化已绑定列表
      this.selectedBindingBackupList = []; //初始化已绑定备份列表
      this.leftLicensePlateNumber = "",
      this.rightLicensePlateNumber = "",
      this.getVehiclesList();
      this.bindingListLoading=false;
    },
    driverChange(value,vehicleId){
      let driverName = this.driverList.filter(d=>d.Id === value)[0].Name;
      let vehicleUnboundFilterList = this.vehicleUnboundList.filter(d=>d.Id === vehicleId);
      vehicleUnboundFilterList.forEach(item=>{
        item.DriverId = value;
        item.DriverName = driverName;
      })
    },
    // 将左边表格选择项存入bindingData中
    handleBindingChange(rows) {
      this.bindingData = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.bindingData.push(row);
          }
        });
      }
    },
    // 将右边表格选择项存入selectedBindingData中
    handleSelectedBindingChange(rows) {
      this.selectedBindingData = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectedBindingData.push(row);
          }
        });
      }
    },
    // 左边表格选择项移到右边
    addBinding() {
      setTimeout(() => {
        this.$refs.unBindingTable.clearSelection();
        this.$refs.selectedBindingTable.clearSelection();
      }, 0);
      
      this.bindingData.forEach(item => {
        item.BusLinesId = this.bindingForm.BusLinesId;
        this.selectedBindingList.push(item);
        this.selectedBindingBackupList.push(item);
      });

      for (let i = 0; i < this.vehicleUnboundList.length; i++) {
        for (let j = 0; j < this.bindingData.length; j++) {
          if (
            this.vehicleUnboundList[i] &&
            this.bindingData[j] &&
            this.vehicleUnboundList[i].LicensePlateNumber === this.bindingData[j].LicensePlateNumber
          ) {
            this.vehicleUnboundList.splice(i, 1);
          }
        }
      }
    },
    // 右边表格选择项移到左边
    removeBinding() {
      setTimeout(() => {
        this.$refs.unBindingTable.clearSelection();
        this.$refs.selectedBindingTable.clearSelection();
      }, 0);

      this.selectedBindingData.forEach(item => {
        item.DriverId = 0;
        this.vehicleUnboundList.push(item);
      });

      for (let i = 0; i < this.selectedBindingList.length; i++) {
        for (let j = 0; j < this.selectedBindingData.length; j++) {
          if (
            this.selectedBindingList[i] &&
            this.selectedBindingData[j] &&
            this.selectedBindingList[i].LicensePlateNumber === this.selectedBindingData[j].LicensePlateNumber
          ) {
            this.selectedBindingList.splice(i, 1);
            this.selectedBindingBackupList.splice(i, 1);
          }
        }
      }
    },
    // 导出
    handleExportExcel(){
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        driverId: _this.filters.driverId,
        vehicleId: _this.filters.vehicleId,
        isBind: 'false',
        page: _this.page,
        pageSize: _this.pageSize
      };
      exportExcel(para).then(res => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
        let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
        // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
        let a = document.createElement("a");
        a.href = url;
        a.download = "线路人车绑定数据(未绑定).xlsx";
        a.click();
        // 5.释放这个临时的对象url
        window.URL.revokeObjectURL(url);
      },
      (err) => {
        resolve(err.response);
      })
      .catch((error) => {
        reject(error);
      });
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            editCompany(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getLineManVehicle();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    // 绑定提交
    bindingSubmit:function() {
      this.$confirm("确认提交吗？", "提示", {}).then(() => {
        this.bindingLoading = true;
        this.bindingForm.Vehicles = this.selectedBindingList;
        let para = Object.assign({}, this.bindingForm);
        putBindingVehiclesList(para).then(res => {
          if (util.isEmt.format(res)) {
            this.bindingLoading = false;
            return;
          }

          if (res.data.success) {
            this.bindingLoading = false;
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.$refs["bindingForm"].resetFields();
            this.bindingFormVisible = false;
            this.$emit('myevent',null);
            this.getLineManVehicle();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    },
    getDriverList(){
      let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: 1,
        pageSize: 200
      };
      getDriverListPage(driverPara).then(res => {
        this.driverList = res.data.response.data;
      });
    },
    getVehiclesList(){
      let vehiclesPara = {
        companyId: '',
        busLinesId: '',
        licensePlateNumber: '',
        terminalsId: '',
        simId: '',
        page: 1,
        pageSize: 200
      };
      getVehiclesListPage(vehiclesPara).then(res => {
        this.vehicleList = res.data.response.data;
        this.vehicleUnboundListInit();
      });
    },
    vehicleUnboundListInit(){
      this.vehicleUnboundList=[];
      this.vehicleList.forEach(item=>{
        if(item.DriverId === 0){
          this.vehicleUnboundList.push(item);
        }
      });
    },
    selectedBindingListInit(){
      this.selectedBindingList=[];
      this.selectedBindingBackupList.forEach(item=>{
        this.selectedBindingList.push(item);
      });
    }
  },
  mounted() {
    this.getLineManVehicle();
    this.getDriverList();
    this.getVehiclesList();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
